import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Assembly = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },
    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-assembly.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Assembly"
                breadEnd="Assembly"
                breadMid="Assembly"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/assembly-img.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                Assemblies are an important aspect of life at Lotus Valley. They
                aim to build a positive school ethos, create and nurture a sense
                of community. Our assemblies foster the development of
                intellect, character and values and inspire students to pursue
                excellence in all its forms. Assemblies serve as a platform for
                the learners to showcase their talent. Learners of all grades,
                from Class I – XII, actively take part in the morning assembly
                and get to learn a great deal about prominent issues confronting
                our society today. Many distinguished and notable people who
                have done exceptional work in varied fields such as Literature,
                Medical Science, Sports and Media regularly become a part of our
                morning assemblies. These eminent personalities influence our
                young learners and inspire them to work assiduously and never
                lose track of their goal in life.
              </p>
              <p>
                Enthralling shows are put up to celebrate the vibrant and
                colourful festivals of India. Festivals such as Holi,
                Janamashtmi, Independence Day, Republic Day, Dussehra, Diwali,
                Guru Nanak Jayanti and Christmas are all celebrated with fervent
                zeal. Our assemblies are replete with songs music, dance and
                drama and all these help students understand the true spirit of
                India, cultivate love for the nation and also develop better
                bonding and bonhomie. Pertinent themes such as Self Awareness
                and Self Esteem, Critical and Creative Thinking, Bullying,
                Habits of Highly Successful People, Power of Words, Bio Mimicry
                are taken up by senior students. Thought -provoking and
                stimulating presentations are made on them.
              </p>
              <p>
                Special days such as World Heritage Day, Environment Day, Human
                Rights Day, Earth Day and International Women’s Day are all
                celebrated with a lot of passion and enthusiasm. Students not
                only become aware of the important happenings of the world
                around them through these assemblies but also develop greater
                confidence and better oratory and theatrical skills.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Assembly;
